import { DivProductPrice } from "../style/ProductPrice.style";
import currencyFormatter from "src/shared/util/currency-formatter";
import Coupon from "src/shared/components/Coupon";
import Discount from "src/shared/components/Discount";
import PriceFormat from "./PriceFormat";

export type ProductPriceVariant = "normal" | "highlight" | "modal";
interface Props {
  price: number | number[];
  retailPrice?: number;
  discount?: string;
  variant?: ProductPriceVariant;
  showCoupon?: boolean;
  showDiscountInsideCoupon?: boolean;
  showDiscount?: boolean;
  showRetailPrice?: boolean;
  showCopyIcon?: boolean;
}

const ProductPrice = ({
  price,
  retailPrice,
  discount,
  variant = "normal",
  showCoupon = true,
  showDiscountInsideCoupon = false,
  showDiscount = false,
  showRetailPrice,
  showCopyIcon = false,
}: Props) => {
  return (
    <DivProductPrice className="akn-product-price-container" $variant={variant}>
      <div className="akn-price-and-retail">
        <span className="akn-product-price">
          <PriceFormat price={price} />
          {showDiscount && discount && <Discount productDiscount={discount} />}
        </span>
        {showRetailPrice && retailPrice && retailPrice !== price && (
          <span className="akn-product-retail-price">
            <PriceFormat price={retailPrice} />
          </span>
        )}
      </div>

      {showCoupon && (
        <Coupon productDiscount={discount} showCopyIcon={showCopyIcon} />
      )}
    </DivProductPrice>
  );
};

export default ProductPrice;
